import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BazowyComponent } from 'src/app/komponenty/bazowy.component';
import { FiltrPorownywaniaDanychNaLiscie } from 'src/app/modele/projekty/magazyny/filtrPorownywaniaDanychNaLiscie';
import { Routing } from 'src/app/modele/wspolne/routing';
import { AuthService } from 'src/app/serwisy/ogolne/auth.service';
import { LoaderService } from 'src/app/serwisy/ogolne/loader.service';
import { EksportDanychService } from 'src/app/serwisy/projekty/eksport-danych.service';
import { PorownywanieDanychService } from 'src/app/serwisy/projekty/porownywanie-danych.service';
import { SpisService } from 'src/app/serwisy/projekty/spis.service';
import { EdytujFiltrPorownywaniaDanychModalComponent } from '../edytuj-filtr-porownywania-danych-modal/edytuj-filtr-porownywania-danych-modal.component';
import { ModalOpcje } from 'src/app/modele/wspolne/modal-opcje.ogolne';
import { PobierzSpisaneSrodkiLokalizacjiFiltry } from 'src/app/modele/projekty/spis/pobierzSpisaneSrodkiLokalizacjiFiltry';
import { RejestrFiltrowanyRequest } from 'src/app/modele/wspolne/rejestrFiltrowanyRequest';
import { UruchomFiltrPorownywaniaDanychModel } from 'src/app/modele/projekty/magazyny/uruchomFiltrPorownywaniaDanychModel';
import {
  Sortowanie,
  KierunekSortowania,
} from 'src/app/modele/wspolne/sortowanie';
import { Stronicowanie } from 'src/app/modele/wspolne/stronicowanie';
import { Subscription } from 'rxjs';
import { KolumnaSpisuFiltrowanie } from 'src/app/modele/projekty/spis/kolumnaSpisuFiltrowanie';

@Component({
  selector: 'app-porownywanie-danych',
  templateUrl: './porownywanie-danych.component.html',
  styleUrls: ['./porownywanie-danych.component.css'],
})
export class PorownywanieDanychComponent
  extends BazowyComponent
  implements OnInit
{
  czyZaladowanoDane: boolean;
  idProjektu: string;
  idLokalizacji: string;
  adresLokalizacji: string;
  filtry: Array<FiltrPorownywaniaDanychNaLiscie> = [];
  idWybranegoFiltra: string;

  calkowitaLiczbaElementow: bigint;
  rozmiarTabeli: number = 35;
  czyJestWiecejRekordow: boolean = true;
  czyPokazacMenuSortowanie: boolean;
  wyszukiwanie: RejestrFiltrowanyRequest<UruchomFiltrPorownywaniaDanychModel> =
    new RejestrFiltrowanyRequest<UruchomFiltrPorownywaniaDanychModel>();
  spisaneSrodki: Array<Array<string>> = new Array();
  kolumnyTabeli: Array<string> = new Array();
  czyPierwszeUruchomienie: boolean = true;
  subsription: Subscription | undefined;
  czyZaladowanoDaneZFiltra: boolean;
  czyPokazanoWyszukiwarkeMobile: boolean;
  kolumnaId: number;
  kolumnaLiczbaRekordow: number;
  kolumnyFiltraDoWyszukiwania: Array<string> = new Array();

  constructor(
    public router: Router,
    modalService: NgbModal,
    loaderSerwis: LoaderService,
    komunikatSerwis: ToastrService,
    public authService: AuthService,
    public spisSerwis: SpisService,
    public translateSerwis: TranslateService,
    private activatedRoute: ActivatedRoute,
    public eksportDanychSerwis: EksportDanychService,
    private porownywanieDanychSerwis: PorownywanieDanychService
  ) {
    super(
      authService,
      modalService,
      loaderSerwis,
      komunikatSerwis,
      router,
      translateSerwis
    );
  }

  ngOnInit(): void {
    setTimeout(() => {
      // this.czyAdministrator = this.czyAdmin();
      this.idLokalizacji =
        this.activatedRoute.snapshot.paramMap.get('idLokalizacji');
      this.idProjektu = this.activatedRoute.snapshot.paramMap.get('idProjektu');
      // this.wyszukiwanie.filtry = new PobierzSpisaneSrodkiLokalizacjiFiltry();
      // this.wyszukiwanie.sortowanie = new Sortowanie(
      //   'data_utworzenia',
      //   KierunekSortowania.asc
      // );
      // this.wyszukiwanie.stronicowanie = new Stronicowanie(false);
      // this.wyszukiwanie.stronicowanie.iloscRekordow = this.rozmiarTabeli;
      // this.wyszukiwanie.stronicowanie.rekordPoczatkowy = 0;
      // this.wyszukiwanie.stronicowanie.strona = 1;
      // this.czyOswiadczenia = this.router.url.includes('statements');

      // this.pobierzFiltryZUrl();
      this.pobierzDaneDoEkranu();
    });
  }

  pobierzDaneDoEkranu() {
    //todo klikanie edytuj w wierszu otworzy nowa karte do edycji zeby nie kasowac przefiltrowanych rekordow

    this.porownywanieDanychSerwis
      .pobierzDaneDoEkranuPorownywaniaDanych(
        this.idProjektu,
        this.idLokalizacji
      )
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.adresLokalizacji = rezultat.element.adresLokalizacji;
          this.filtry = rezultat.element.filtry;

          this.czyZaladowanoDane = true;
          return;
        }
        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      });
  }

  wybierzFiltr(id: string) {
    this.czyZaladowanoDaneZFiltra = false;
    if (this.idWybranegoFiltra == id) {
      this.idWybranegoFiltra = undefined;
      this.spisaneSrodki = [];
      return;
    }
    this.idWybranegoFiltra = id;
    this.czyPierwszeUruchomienie = true;

    this.pobierzDaneNaPodstawieFiltra(true);
  }

  pobierzDaneNaPodstawieFiltra(zLadowaczem, odswiezanie = false) {
    if (this.czyPierwszeUruchomienie) {
      this.wyszukiwanie.filtry = new UruchomFiltrPorownywaniaDanychModel();
      this.wyszukiwanie.sortowanie = new Sortowanie(
        'id',
        KierunekSortowania.asc
      );
      this.wyszukiwanie.stronicowanie = new Stronicowanie(false);
      this.wyszukiwanie.stronicowanie.iloscRekordow = this.rozmiarTabeli;
      this.wyszukiwanie.stronicowanie.rekordPoczatkowy = 0;
      this.wyszukiwanie.stronicowanie.strona = 1;
      this.wyszukiwanie.filtry.idLokalizacji = this.idLokalizacji;
      this.wyszukiwanie.filtry.idProjektu = this.idProjektu;
    }

    this.wyszukiwanie.filtry.idFiltra = this.idWybranegoFiltra;

    this.subsription = this.porownywanieDanychSerwis
      .uruchomFiltr(this.wyszukiwanie, zLadowaczem)
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.spisaneSrodki = rezultat.element.dane;
          this.calkowitaLiczbaElementow =
            rezultat.element.calkowitaIloscRekordow;
          this.czyJestWiecejRekordow = rezultat.element.czyJestWiecejRekordow;
          this.kolumnyTabeli = rezultat.element.kolumny;
          this.kolumnaId = this.kolumnyTabeli.indexOf('id');
          this.kolumnaLiczbaRekordow = this.kolumnyTabeli.indexOf(
            'liczba_rekordow_spis'
          );
          this.kolumnyFiltraDoWyszukiwania =
            rezultat.element.kolumnyFiltraDoWyszukiwania;
          //  this.kolumnaCzyMojSrodek = this.kolumnyTabeli.indexOf('czy_moj_srodek');
          //  this.statusProjektu = rezultat.element.statusProjektu;

          if (
            this.spisaneSrodki.length == 0 &&
            !this.czyJestWiecejRekordow &&
            this.calkowitaLiczbaElementow > 0n
          ) {
            this.wyszukiwanie.stronicowanie.rekordPoczatkowy = 0;
            this.wyszukiwanie.stronicowanie.strona = 1;
            this.pobierzDaneNaPodstawieFiltra(true);
            return;
          }
          if (this.czyPierwszeUruchomienie) {
            this.przygotujFiltry();
            this.czyPierwszeUruchomienie = false;
          }
          if (odswiezanie) {
            this.przygotujFiltryPoOdswiezeniu();
          }

          this.czyZaladowanoDaneZFiltra = true;
          return;
        }
        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      });
  }

  przygotujFiltry() {
    this.wyszukiwanie.filtry.kolumnyFiltrowania = new Array();
    this.kolumnyTabeli.forEach((kolumna) => {
      if (kolumna == 'id' || kolumna == 'liczba_rekordow_spis') {
        return;
      }
      var kolumnaFiltrowania = new KolumnaSpisuFiltrowanie();
      kolumnaFiltrowania.kolumna = kolumna;
      // kolumnaFiltrowania.wartoscSzukaj =
      //   this.filtryZUrl.find((m) => m.kolumna == kolumna)?.wartoscSzukaj || '';
      this.wyszukiwanie.filtry.kolumnyFiltrowania.push(kolumnaFiltrowania);
    });
  }

  przygotujFiltryPoOdswiezeniu() {
    var aktualneFiltry = [...this.wyszukiwanie.filtry.kolumnyFiltrowania];
    this.wyszukiwanie.filtry.kolumnyFiltrowania = new Array();
    this.kolumnyTabeli.forEach((kolumna) => {
      if (kolumna == 'id' || kolumna == 'liczba_rekordow_spis') {
        return;
      }
      var kolumnaFiltrowania = new KolumnaSpisuFiltrowanie();
      kolumnaFiltrowania.kolumna = kolumna;
      kolumnaFiltrowania.wartoscSzukaj =
        aktualneFiltry.find((m) => m.kolumna == kolumna)?.wartoscSzukaj || '';
      this.wyszukiwanie.filtry.kolumnyFiltrowania.push(kolumnaFiltrowania);
    });
  }

  czyPokazacWyczyscFiltry() {
    if (!this.czyZaladowanoDaneZFiltra) {
      return false;
    }
    return (
      this.wyszukiwanie.filtry.kolumnyFiltrowania.filter((m) => m.wartoscSzukaj)
        .length > 0
    );
  }
  pokazWyszukiwarkeMobile(czyPokazac: boolean) {
    this.czyPokazanoWyszukiwarkeMobile = czyPokazac;
  }

  cofnij() {
    this.router.navigate([
      Routing.PomieszczeniaLokalizacji,
      this.idProjektu,
      this.idLokalizacji,
    ]);
  }

  edytujFiltr(id) {
    this.modalReference = this.modalService.open(
      EdytujFiltrPorownywaniaDanychModalComponent,
      new ModalOpcje(true, 'static')
    );
    this.modalReference.componentInstance.idLokalizacji = this.idLokalizacji;
    this.modalReference.componentInstance.idProjektu = this.idProjektu;
    this.modalReference.componentInstance.idFiltra = id;
    this.modalReference.result.then(
      (result) => {
        if (result) {
          this.pobierzDaneDoEkranu();
        }
      },
      (onRejected) => {}
    );
  }

  eksportujDane() {
    if (!this.idWybranegoFiltra) {
      return;
    }
    this.eksportDanychSerwis
      .eksportujPorownaneDaneLokalizacji(
        this.idProjektu,
        this.idLokalizacji,
        this.idWybranegoFiltra
      )
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.bledyWalidacji = null;
          var a = document.createElement('a');
          a.target = '_blank';
          a.href =
            'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
            rezultat.element.plik;
          a.download = rezultat.element.nazwaPliku;
          a.click();
          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      });
  }

  generujArkuszSpisu() {
    if (!this.idWybranegoFiltra) {
      return;
    }
    const url = this.router
      .createUrlTree(
        [
          Routing.PorownywanieDanychArkusz,
          this.idProjektu,
          this.idLokalizacji,
          this.idWybranegoFiltra,
        ],
        {
          queryParams: this.budujQueryParamsDlaArkusza(),
          queryParamsHandling: '',
        }
      )
      .toString();
    window.open(url, '_blank');

    // this.router.navigate(
    //   [
    //     Routing.PorownywanieDanych,
    //     Routing.ArkuszSpisu,
    //     this.idProjektu,
    //     this.idLokalizacji,
    //     this.idWybranegoFiltra,
    //   ],
    //   {
    //     queryParams: this.budujQueryParamsDlaArkusza(),
    //     queryParamsHandling: '',
    //   }
    // );
  }

  pobierzKierunekSortowania(kolumna: string) {
    if (!this.wyszukiwanie.sortowanie) {
      return '';
    }

    var kierunki = this.wyszukiwanie.sortowanie.listaSortowania;

    var kierunek = kierunki.find((m) => m.nazwaKolumny == kolumna);

    if (kierunek == undefined) {
      return '';
    }

    if (kierunek.kierunekSortowania == KierunekSortowania.asc) {
      return 'up';
    }
    if (kierunek.kierunekSortowania == KierunekSortowania.desc) {
      return 'down';
    }
  }

  zmienKierunekSortowania(kolumna: string) {
    this.czyPokazacMenuSortowanie = false;
    var kierunki = this.wyszukiwanie.sortowanie.listaSortowania;

    var kierunek = kierunki.find((m) => m.nazwaKolumny == kolumna);

    if (kierunek == undefined) {
      this.wyszukiwanie.sortowanie = new Sortowanie(
        kolumna,
        KierunekSortowania.asc
      );
      this.pobierzDaneNaPodstawieFiltra(true);
      return;
    }

    if (kierunek.kierunekSortowania == KierunekSortowania.asc) {
      this.wyszukiwanie.sortowanie = new Sortowanie(
        kolumna,
        KierunekSortowania.desc
      );
      this.pobierzDaneNaPodstawieFiltra(true);
      return;
    }
    if (kierunek.kierunekSortowania == KierunekSortowania.desc) {
      this.wyszukiwanie.sortowanie = new Sortowanie(
        'id',
        KierunekSortowania.asc
      );
      this.pobierzDaneNaPodstawieFiltra(true);
      return;
    }
  }

  wyczyscFiltry() {
    this.wyszukiwanie.filtry.kolumnyFiltrowania.forEach((k) => {
      k.wartoscSzukaj = '';
    });
    this.pobierzDaneNaPodstawieFiltra(true);
  }

  filtrujPoTekscie(event: any, kolumna: string) {
    this.wyszukiwanie.stronicowanie.rekordPoczatkowy = 0;
    this.wyszukiwanie.stronicowanie.strona = 1;
    var wartosc = event.target.value.toString();

    this.ustawWartoscFiltrowania(kolumna, wartosc);

    this.subsription?.unsubscribe();

    this.pobierzDaneNaPodstawieFiltra(false);
  }

  ustawWartoscFiltrowania(kolumna: string, wartosc: string) {
    var kolumnaFiltrowania = this.wyszukiwanie.filtry.kolumnyFiltrowania.find(
      (m) => m.kolumna == kolumna
    );

    if (kolumnaFiltrowania == undefined) {
      kolumnaFiltrowania = new KolumnaSpisuFiltrowanie();
      kolumnaFiltrowania.kolumna = kolumna;
      kolumnaFiltrowania.wartoscSzukaj = wartosc;
      this.wyszukiwanie.filtry.kolumnyFiltrowania.push(kolumnaFiltrowania);
    } else {
      this.wyszukiwanie.filtry.kolumnyFiltrowania.forEach((k) => {
        if (k.kolumna == kolumna) {
          k.wartoscSzukaj = wartosc;
        }
      });
    }
  }

  czyPokazacPrzyciskCzyszczeniaFiltru(kolumna: string) {
    var kolumnaFiltrowania = this.wyszukiwanie.filtry.kolumnyFiltrowania.find(
      (m) => m.kolumna == kolumna
    );
    return kolumnaFiltrowania != undefined && kolumnaFiltrowania.wartoscSzukaj;
  }
  wyczyscFiltrKolumny(kolumna: string) {
    this.wyszukiwanie.filtry.kolumnyFiltrowania.forEach((k) => {
      if (k.kolumna == kolumna) {
        k.wartoscSzukaj = '';
      }
    });
    this.pobierzDaneNaPodstawieFiltra(false);
  }

  zmienRozmiarTabeli() {
    this.wyszukiwanie.stronicowanie.iloscRekordow = this.rozmiarTabeli;
    this.pobierzDaneNaPodstawieFiltra(true);
  }

  pobierzNumerRekorduPoczatek() {
    if (this.wyszukiwanie.stronicowanie == undefined) {
      return 1;
    }
    return this.wyszukiwanie.stronicowanie.rekordPoczatkowy + 1;
  }
  pobierzNumerRekorduKoniec() {
    if (this.wyszukiwanie.stronicowanie == undefined) {
      return 1;
    }
    return (
      this.wyszukiwanie.stronicowanie.rekordPoczatkowy +
      this.spisaneSrodki.length
    );
  }
  zmienStrone(oIle: number) {
    this.wyszukiwanie.stronicowanie.strona += oIle;
    this.wyszukiwanie.stronicowanie.rekordPoczatkowy =
      (this.wyszukiwanie.stronicowanie.strona - 1) *
      this.wyszukiwanie.stronicowanie.iloscRekordow;
    this.pobierzDaneNaPodstawieFiltra(true);
  }

  edytujSrodek(rekord: Array<string>) {
    var id = rekord[this.kolumnaId];

    const url = this.router
      .createUrlTree([
        Routing.EdycjaSrodka,
        this.idProjektu,
        this.idLokalizacji,
        id,
      ])
      .toString();
    window.open(url, '_blank');
  }

  wyszukajSrodki(rekord: Array<string>) {
    var id = rekord[this.kolumnaId];

    //todo

    const url = this.router
      .createUrlTree(
        [Routing.SpisaneSrodkiLokalizacji, this.idProjektu, this.idLokalizacji],
        {
          queryParams: this.budujQueryParamsDlaRekordu(rekord),
          queryParamsHandling: '',
        }
      )
      .toString();
    window.open(url, '_blank');
  }

  budujQueryParamsDlaRekordu(rekord: Array<string>) {
    var filtry = [];

    this.kolumnyFiltraDoWyszukiwania.forEach((m) => {
      var indeksKolumny = this.kolumnyTabeli.indexOf(m);
      filtry.push({ [m]: rekord[indeksKolumny] });
    });

    // var filtry = this.wyszukiwanie?.filtry?.kolumnyFiltrowania
    //   ?.filter((m) => m.wartoscSzukaj)
    //   .map((m) => ({ [m.kolumna]: m.wartoscSzukaj }));

    return Object.assign({}, ...[...filtry]);
  }

  budujQueryParamsDlaArkusza() {
    var filtry = this.wyszukiwanie?.filtry?.kolumnyFiltrowania
      ?.filter((m) => m.wartoscSzukaj)
      .map((m) => ({ [m.kolumna]: m.wartoscSzukaj }));

    return Object.assign(
      {},
      ...[
        // { ['strona']: this.wyszukiwanie.stronicowanie.strona },
        // { ['rozmiarStrony']: this.rozmiarTabeli },
        {
          ['sortowanieKolumna']:
            this.wyszukiwanie.sortowanie.listaSortowania[0].nazwaKolumny,
        },
        {
          ['sortowanieKierunek']:
            this.wyszukiwanie.sortowanie.listaSortowania[0].kierunekSortowania,
        },
        ...filtry,
      ]
    );
  }
}
